module.exports = __webpack_public_path__ + "img/icon_1_1.82043bdc.png";